module.exports = __webpack_public_path__ + "img/honor-4.f2cfc15b.png";